import React from 'react';

interface LinedButtonProps {
  children: React.ReactNode;
  onClick: () => void; // Changed: no parameter expected.
}

const LinedButton: React.FC<LinedButtonProps> = ({ children, onClick }) => {
  return (
    <button
      className="text-base rounded-lg border p-2"
      onClick={onClick}  // Directly pass the onClick function.
    >
      {children}
    </button>
  );
};

export default LinedButton;
